import SpotifyRequestError from 'utils/SpotifyRequestError';
import { firebase } from 'firebase/fbConfig.js';

const httpCall = async (fnName, arg) => {
  const fn = firebase.functions().httpsCallable(fnName);
  const { data } = await fn(arg);
  const { error } = data || {};
  if (error) {
    console.log(error);
    throw new SpotifyRequestError(error);
  }
  return data;
};

export const getCuratedTracks = async (genres) => 
  !genres || !genres.length ? [] : await getRecommendedTracks({ type: 'genres', references: genres });
  
export const getRecommendedTracks = async (params) =>
  await httpCall('spotifyGetRecommendations', params);

export const getFeaturedTracks = async (params) =>
  await httpCall('spotifyGetFeaturedTracks', params);

export const getTrendingTracks = async (params) =>
  await httpCall('spotifyGetTrendingTracks', params);

export const getNewReleases = async (params) =>
  await httpCall('spotifyGetNewReleases', params);

export const getUserTopTracks = async (params) =>
  await httpCall('spotifyGetUserTopTracks', params);

export const getUserImprint = async (params) =>
  await httpCall('spotifyGetUserImprint', params);

export const getNewUserToken = async (params) =>
  await httpCall('spotifyGetNewUserToken', params);

///////////////////////////////////////////////////////////
// export const getUserTopTracks = async () => {
//   try {
//     const token =
//       'QBQI7WsySr95sXzFDU6udl3VeBg8OuCs5lH_TtvIjpVagUDUBqQNqWGI_jyrhRiwqawCkqL9woSByrPjjbeRLjVEn4BNSEu_Tu-rO-uysSVayb4HXcMEICPaINm0IBJHw41tG3Az2I2mmOn4Gi2PGaziRAQjYLYdJDOwJ2L3eh3JWN-CVdEF1EttzzS';
//     const axiosConfig = {
//       headers: { Authorization: `Bearer ${token}` },
//     };
//     const spotifyBaseUrl = 'https://api.spotify.com/v1/';
//     const url = `${spotifyBaseUrl}me/top/tracks`;
//     // Get the list of tracks from the spotify api
//     const data = await axios.get(url, axiosConfig);
//     // const tracks = data.items.map((e) => e.track);
//     // return await spotifyExtractTracksData(tracks);
//   } catch (error) {
//     console.log('START ERROR ==================');
//     console.log(error.response.data.error.message);
//     console.log(error.response.status);
//     console.log('END ERROR ==================');
//   }
// };
